import type { FC, PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, type ButtonProps, type Sx } from '@dhl-ui/components'
import { WithFixedBottomComponent } from './WithFixedBottomComponent.js'

type Props = {
  buttonProps?: ButtonProps
  buttonText?: string
  dataTest?: string
  disabled?: boolean
  isLoading?: boolean
  onClick?: () => void
  sx?: Sx
}

export const WithFixedBottomSaveButton: FC<PropsWithChildren<Props>> = ({
  buttonText,
  children,
  buttonProps,
  dataTest,
  isLoading,
  sx,
  ...rest
}: PropsWithChildren<Props>) => {
  const { t } = useTranslation()

  return (
    <WithFixedBottomComponent
      element={
        <Button
          fullWidth
          loading={isLoading}
          type="submit"
          variant="contained"
          {...buttonProps}
          data-test={dataTest}
          data-testid={dataTest}
          {...rest}
        >
          {buttonText ?? t('common.saveButton')}
        </Button>
      }
      sx={sx}
    >
      {children}
    </WithFixedBottomComponent>
  )
}
